import { render, staticRenderFns } from "./WorkoutsListTable.vue?vue&type=template&id=887ac35c&scoped=true&"
import script from "./WorkoutsListTable.vue?vue&type=script&lang=js&"
export * from "./WorkoutsListTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutsListTable.vue?vue&type=style&index=0&id=887ac35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887ac35c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
